export enum Currencies {
  euro = '€',
  dollar = '$',
}

export const INPUT_VALUE_CURRENCY_SYMBOL_MARGIN = 5;
